import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'Bono 1: +30 recetas rápidas',
  desc: 'Ideas simples, prácticas y sabrosas para esos días donde no querés pensar.'
}, {
  title: 'Bono 2: Guía de guarniciones perfectas',
  desc: 'Papas, ensaladas, purés, arroz, verduras, opciones rápidas y combinaciones ganadoras.'
}, {
  title: 'Bono 3: Organización semanal y meal prep',
  desc: 'Para preparar, freezar, planificar y resolver comidas durante la semana sin vivir improvisando.'
}, {
  title: 'Bono 4: Guía de los mejores cortes y cómo cocinarlos',
  desc: 'Aprende a elegir la carne perfecta para cada ocasión y presupuesto.'
}];
export function Bonuses() {
  return <section className="bg-crema text-bordo py-12 px-4 md:px-8" data-id="element-34">
      <div className="max-w-4xl mx-auto" data-id="element-35">
        <div className="text-center mb-8" data-id="element-36">
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4" data-id="element-37">
            Y además incluye bonos pensados para que uses el producto de verdad:
          </h2>
          <div className="inline-block bg-bordo text-dorado font-bold px-5 py-1.5 rounded-full text-lg animate-pulse" data-id="element-38">
            GRATIS POR EL DÍA DE HOY
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-39">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-md border border-bordo/10" data-id="element-40">
              <Gift className="text-dorado shrink-0 mt-0.5" size={22} data-id="element-41" />
              <div data-id="element-42">
                <h3 className="font-bold text-base mb-1" data-id="element-43">{bonus.title}</h3>
                <p className="text-sm text-gray-600" data-id="element-44">{bonus.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}